export default __webpack_public_path__ + "static/media/link3.02b8eda8.png";